import axios from 'commonjs/axios';

export default class PagseguroHandler {
    constructor(clientURL, actions){
        this.clientURL = clientURL;
        this.scriptsLoaded = false;
        this.code = null;
        this.scriptUrl = null;
        this.referenceId = null;
        this.redirectUrl = null;
        this.actions = actions;
    }

    initCheckout(){
        this.pagseguroGetCode();
    }

    setPaymentUrl(paymentUrl){
        this.paymentUrl = paymentUrl;
    }
    
    pagseguroGetCode(){
        this.actions.setLoading(true);
		axios.get(this.paymentUrl).then( response => {
            if(response.data.success){
                if( typeof response.data.code == 'undefined' &&  typeof response.data.redirectUrl != 'undefined'  ){
                    //If there is no charge the pagseguro payment gatway will be not initialized
                    window.location.href= response.data.redirectUrl;
                    return;
                }
                this.code = response.data.code;
                this.scriptUrl = response.data.scriptUrl;
                this.referenceId = response.data.referenceId;
                this.redirectUrl = response.data.redirectUrl;
                if(!this.scriptsLoaded){
                    this.loadScripts();
                }else{
                    this.initLightbox();
                }
                
            }else{
                this.actions.setErrors(response.data.errors);
                this.actions.setLoading(false);
            }
        }).catch( e => {
            this.actions.setErrors(response.data.errors);
            this.actions.setLoading(false);
        })
    }
    loadScripts(){
        var script = document.createElement('script');
        script.onload = (e) => {
            
            console.log('script loaded', e);
            this.scriptsLoaded = true;
            this.initLightbox();
        };
        script.src = this.scriptUrl;
        document.head.appendChild(script);        
    }

    sendTransactionCode(transactionCode){
        console.log('sendTrasactionCode', transactionCode);        
        axios.get( this.clientURL + '/billing/pagseguro/success/' + this.referenceId + '?transaction_id=' + transactionCode).then(response =>{
            window.location.href= this.redirectUrl;
        }).catch(e=>{
            this.actions.setErrors(response.data.errors);
            this.actions.setLoading(false);
            window.location.href= this.redirectUrl;
        })

    }
    abortTransaction(){
        this.actions.setLoading(false);
    }

    initLightbox(){			
		window.PagSeguroLightbox({
				code: this.code
			}, 
			{
				success: transactionCode => {
					this.sendTransactionCode(transactionCode);
				},
				abort: ()=>{					
				    this.abortTransaction();
				}
			});
		
	}

}